import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  faList,
  faTh,
  faHourglassStart,
} from "@fortawesome/free-solid-svg-icons";
import {
  VAIconRegistryService,
  checkCircle,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-labs-reports",
  templateUrl: "./labs-reports.component.html",
  styleUrls: ["./labs-reports.component.scss"],
  host: { class: "labs-reports-component" },
})
export class LabsReportsComponent implements OnInit, OnChanges {
  faList = faList;
  faTh = faTh;
  faHourglassStart = faHourglassStart;

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([
      checkCircle,
      checkCircle,
      exclamationTriangle,
    ]);
  }

  public isListView = true;
  public filterReportList: any[] = [];

  @Input() reportType = "";
  @Input() reportTypeList: any[] = [];
  @Input() reportList: any[] = [];

  ngOnInit() {
    this.filterReport();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ("reportType" in changes) {
      if (
        changes.reportType.currentValue !== undefined &&
        changes.reportType.previousValue !== undefined
      ) {
        this.filterReport();
      }
    }
    if ("reportList" in changes) {
      if (
        changes.reportList.currentValue !== undefined &&
        changes.reportList.previousValue !== undefined
      ) {
        this.filterReport();
      }
    }
  }

  public filterReport() {
    if (this.reportList.length > 0) {
      if (this.reportType !== "") {
        this.filterReportList = this.reportList;
        // .filter((x) => x.report_level <= reportType.level)
        // .sort((a, b) => {
        //   return a.report_level > b.report_level ? 1 : -1;
        // });
      }
    }
  }

  public showHideReportView(viewType) {
    if (viewType === "list") {
      this.isListView = true;
    } else {
      this.isListView = false;
    }
  }
}
